import { Stepper } from "./Stepper";

import { useTimeHandler } from "@/hooks";
import { TimeSettingsButtons } from "../TimeSettingsButtons";

export const DateTimeNavigation = () => {
  const { time, handleTimeChange } = useTimeHandler();

  return (
    <Stepper onChange={handleTimeChange}>
      <TimeSettingsButtons visibleTime={time} />
    </Stepper>
  );
};
